import React from 'react';
import { useSelector } from 'react-redux';

function AttendeeName({ name, key ,isCircular = false }) {
    const { roomDetail } = useSelector(state => state.conf);
    console.log('isCircular', isCircular);
    return (
        <>
            {
                roomDetail?.show_names_on_videos && <div
                className={isCircular ? 'blur-div-circular' : 'blur-div-left'}
                    key={key || ''}
                    dangerouslySetInnerHTML={{ __html: name }}
                />
            }
        </>

    );

}

export default AttendeeName;
